import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logos from '../../../assets/logo/logo-header.png';
import { formatCurrency } from '../../../common/utils';
import Button from '../../../components/bootstrap/Button';
import Popovers from '../../../components/bootstrap/Popovers';
import {
	History,
	Logout,
	NotInterested,
	People,
	QueryStats,
	Search,
} from '../../../components/icon/material-icons';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import { useUserStore } from '../../../stores/useUserStore';

const DefaultHeader = () => {
	const navigate = useNavigate();
	const { user, logout } = useUserStore();

	const handleLogout = async () => {
		try {
			await logout();
			navigate('/login');
		} catch (error) {
			console.error('Errore durante il logout:', error);
		}
	};

	useEffect(() => {
		if (!user) navigate('/login');
	}, [user]);

	const goToLeads = () => {
		navigate(`../users`);
	};

	const goToBlacklist = () => {
		navigate(`../blacklist`);
	};

	const goToHistoryFile = () => {
		navigate(`../history-file`);
	};

	const goToTrackNumber = () => {
		navigate(`../track-number`);
	};

	const goToHome = () => {
		navigate(`../homepage`);
	};

	return (
		<Header>
			<HeaderLeft className='d-flex flex-wrap align-items-center gap-2'>
				<div className='d-inline-flex flex-shrink-0' style={{ maxWidth: 160 }}>
					<img
						src={logos}
						alt='Logo'
						className='img-fluid'
						style={{ maxWidth: '100%', height: 'auto' }}
					/>
				</div>
				<nav className='header-nav d-flex flex-wrap align-items-center gap-2'>
					<Popovers trigger='hover' desc='Dashboard'>
						<Button color='primary' onClick={goToHome} size='sm' className='header-nav__btn'>
							<QueryStats fontSize={'18px'} /> Dashboard
						</Button>
					</Popovers>
					{user && user.admin && (
						<Popovers trigger='hover' desc='Utenti'>
							<Button color='primary' onClick={goToLeads} size='sm' className='header-nav__btn'>
								<People fontSize={'18px'} /> Utenti
							</Button>
						</Popovers>
					)}
					<Popovers trigger='hover' desc='Storico file'>
						<Button color='primary' onClick={goToHistoryFile} size='sm' className='header-nav__btn'>
							<History fontSize={'18px'} /> Storico file
						</Button>
					</Popovers>
					<Popovers trigger='hover' desc='Ricerca tracciato'>
						<Button color='primary' onClick={goToTrackNumber} size='sm' className='header-nav__btn'>
							<Search fontSize={'18px'} /> Ricerca tracciato
						</Button>
					</Popovers>
					{user && user.admin && (
						<Popovers trigger='hover' desc='Blacklist'>
							<Button color='primary' onClick={goToBlacklist} size='sm' className='header-nav__btn'>
								<NotInterested fontSize={'18px'} /> Blacklist
							</Button>
						</Popovers>
					)}
				</nav>
			</HeaderLeft>

			<HeaderRight className='d-flex flex-column flex-sm-row align-items-center'>
				<div className='me-3 d-flex align-items-center'>
					<span className='ms-2 fs-5'>
						{' '}
						{/* Aumenta la grandezza del testo */}
						Bentornato, <strong>{user?.username}</strong>
					</span>
				</div>

				{/* Credito e Listino come bottoni non cliccabili */}
				<div className='d-flex me-4 flex-column flex-sm-row'>
					<span className='badge bg-success text-white me-3 p-3 fs-6'>
						{' '}
						{/* Aumenta la grandezza dei badge */}
						{formatCurrency(user?.credito)}
					</span>
					<span className='badge bg-warning text-white p-3 fs-6'>
						{' '}
						{/* Aumenta la grandezza dei badge */}
						{formatCurrency(user?.listinoPrezzi)}
					</span>
				</div>

				{/* Bottone di Logout */}
				<Button color='danger' onClick={handleLogout}>
					<Logout fontSize={'20px'} /> {/* Aumenta la grandezza dell'icona e del testo */}
				</Button>
			</HeaderRight>
		</Header>
	);
};

export default DefaultHeader;
